import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, TrendingUp, Globe, Palette, Camera, Video, Brain, Megaphone, Phone, Briefcase, Target } from 'lucide-react';
import { services } from '../../data/mock';
import { Button } from '../ui/button';

const iconComponents = {
  TrendingUp,
  Globe,
  Palette,
  Camera,
  Video,
  Brain,
  Megaphone,
  Phone,
  Briefcase,
  Target,
};

const ServicesSection = () => {
  return (
    <section className="py-24 bg-gradient-to-b from-white to-blue-50/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-16">
          <div>
            <span className="inline-flex items-center px-3 py-1 rounded-full bg-blue-50 text-blue-600 text-sm font-medium mb-4">
              What We Offer
            </span>
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900">
              360° Business <span className="text-blue-600">Solutions</span>
            </h2>
          </div>
          <Link to="/services" className="mt-4 md:mt-0">
            <Button variant="ghost" className="text-blue-600 hover:text-blue-700 hover:bg-blue-50 group">
              View All Services
              <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" />
            </Button>
          </Link>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.slice(0, 6).map((service) => {
            const Icon = iconComponents[service.icon] || Target;
            const isAI = service.title.includes('AI');
            return (
              <div
                key={service.id}
                className={`group p-6 bg-white border rounded-2xl card-hover ${
                  isAI 
                    ? 'border-blue-200 bg-gradient-to-br from-blue-50/50 to-white shadow-lg shadow-blue-100/50' 
                    : 'border-gray-100 hover:border-blue-200'
                }`}
              >
                <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-4 ${
                  isAI 
                    ? 'bg-blue-600 text-white' 
                    : 'bg-blue-50 text-blue-600 group-hover:bg-blue-600 group-hover:text-white'
                } transition-colors`}>
                  <Icon className="w-6 h-6" />
                </div>
                {isAI && (
                  <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-blue-600 text-white text-xs font-medium mb-2">
                    Featured
                  </span>
                )}
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  {service.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {service.shortDesc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
